export enum Relationship {
Child,
Spouse,
Parent,
Sibling,
}
